// Past-tense spending verbs, compared without accents so "gaste" counts as
// "gasté": people often skip accents when typing on a phone.
const SPENDING_VERBS = [
  // English
  'spent', 'paid', 'bought', 'purchased',
  // Spanish
  'gaste', 'pague', 'compre', 'cobraron',
];

const VERB_RE = new RegExp(`\\b(${SPENDING_VERBS.join('|')})\\b`);

// A year after a period word or a month ("in 2025", "desde 2024", "septiembre
// de 2025") names a period, not an amount. A bare 2000 stays an amount, and so
// do "for 2000" and "un pan de 2000": COP 2,000 is an everyday purchase.
const MONTHS = [
  'january', 'february', 'march', 'april', 'may', 'june', 'july', 'august',
  'september', 'october', 'november', 'december',
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto',
  'septiembre', 'setiembre', 'octubre', 'noviembre', 'diciembre',
];
const PERIOD_YEAR_RE = new RegExp(
  `\\b(in|en|del|since|desde|during|durante|(${MONTHS.join('|')})(\\s+de)?)\\s+(19|20)\\d{2}\\b`,
  'g',
);
const MONTH = `(${MONTHS.join('|')})`;

// Numbers that are not amounts: a day of the month ("el 15 de septiembre",
// "September 5th", "on the 5"), an ordinal, or a duration ("1 hour"). "el 20
// mil" and "el 15.000" stay amounts.
const NON_AMOUNT_RES = [
  new RegExp(`\\b\\d{1,2}\\s+(de\\s+)?${MONTH}\\b`, 'g'),
  new RegExp(`\\b${MONTH}\\s+\\d{1,2}(st|nd|rd|th)?\\b`, 'g'),
  /\b\d{1,2}(st|nd|rd|th)\b/g,
  /\b(on the|el)\s+\d{1,2}\b(?![.,]?\d|\s*(mil|k|lucas|%))/g,
  /\b\d+([.,]\d+)?\s*(hours?|hrs?|horas?|minutes?|mins?|minutos?)\b/g,
];
const AMOUNT_RE = /\d/;

// A question about the past ("how much have I spent in the last 3 months?")
// is not a purchase report, even when it holds a number. A leading "qué" is
// not taken as a question: it opens exclamations too ("qué caro, pagué 50
// mil"), so a "qué" question is caught by its "?".
const QUESTION_RE = /[?¿]|^(how|what|when|where|which|cuanto|cuanta|cuantos|cuantas|cuando|donde|cual)\b/;

const plain = (text) => (text || '')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .toLowerCase();

/**
 * True when a message reads like the owner reporting a purchase ("I spent 20k
 * on a taxi", "gasté 20 mil en taxi"): it holds an amount and a past-tense
 * spending verb, and is not a question ("how much have I spent in the last 3
 * months?" does not match).
 */
export function looksLikeSpending(text) {
  const s = plain(text);
  if (QUESTION_RE.test(s.trim())) return false;
  const amounts = NON_AMOUNT_RES.reduce((acc, re) => acc.replace(re, ' '), s.replace(PERIOD_YEAR_RE, ' '));
  return VERB_RE.test(s) && AMOUNT_RE.test(amounts);
}
